import React, { useEffect, useState } from "react"
import { useGameFact } from "./useGameFact.js"

import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import MobileStepper from '@mui/material/MobileStepper';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';

import { createGameFact, updateGameFact } from '../../../actions/gameFact.js'
import { useDispatch, useSelector } from "react-redux"
import { Grid, IconButton, Stack } from "@mui/material";

import CancelIcon from '@mui/icons-material/Cancel';
import CheckIcon from '@mui/icons-material/Check';
import SearchBar from "./generic/SearchBar.js";
import SelectPlayerInTeam from "./generic/SelectPlayerInTeam.js";

const GameFact = ({gameFact, endProcess, match, callback, surchargePeriod}) => {

    const [img, imgSucceed, imgFailed, steps, state, setState, recapComponent] = useGameFact(gameFact)

    const theme = useTheme();
    
    const [activeStep, setActiveStep] = React.useState(0);
    const maxSteps = steps.length;

    const [searchFilter, setSearchFilter] = useState('')

    useEffect(() => {
      setActiveStep(0)

    }, [gameFact.type])

    const onSelect = (idItem) => {
        setState(s => ({...s, [steps[activeStep].id] : idItem, edited : steps[activeStep].id!=='timer'}))
        if(steps[activeStep].out!==undefined && steps[activeStep].out === idItem)
          endProcess()
        else
          handleNext()
    }

    const onChangeText = (text) => {
      setState(s => ({...s, text}))
    }

    const onChangeTitle = (title) => {
      setState(s => ({...s, title}))
    }

    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
        setSearchFilter('')
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
        setSearchFilter('')
    };

    // API
    const dispatch = useDispatch()

    const saveGameFact = (gameFactData) => {

      if(gameFact._id){
          dispatch(updateGameFact(gameFactData, gameFact._id))
        }else{
          dispatch(createGameFact(gameFactData, gameFact.type, match))
        }
        
        endProcess()
    }

    return (
        <Box sx={{ flexGrow: 1, background : '#3160A3'}}>
           <Box sx={{ background : 'white', padding : 1, textAlign : "center", position : 'relative', marginBottom : 2}}>

              <img src={img} width={150} sx={{ imageRendering : 'optimized'}}/>
              <Typography>{activeStep < steps.length ? steps[activeStep].label : "Récapitulatif du fait de jeu"}</Typography>

              <IconButton aria-label="cancel" color="primary" sx={{position : 'absolute', top : 5, right : 5}} onClick={() => endProcess()}>
                <CancelIcon />
              </IconButton>

            </Box>
          <Box sx={{ height: 325, p: 2, overflowY : 'auto' }}>
            {steps[activeStep] && steps[activeStep].searchFilter && <Stack alignItems="center" marginBottom={2}>
              <SearchBar setSearchFilter={setSearchFilter}/>
            </Stack>}
            
            <GenericGameFact 
                searchFilter={searchFilter} 
                steps={steps} 
                state={state} 
                activeStep={activeStep} 
                onSelect={onSelect} 
                recapComponent={recapComponent} 
                match={match} 
                onChangeText={onChangeText} 
                onChangeTitle={onChangeTitle} surchargePeriod={surchargePeriod}
            />
          </Box>
          {activeStep < steps.length ?
          <MobileStepper
            variant="text"
            steps={maxSteps}
            position="static"
            activeStep={activeStep}
            nextButton={
              <Button
                size="small"
                onClick={handleNext}
                disabled={state[steps[activeStep].id]===undefined}
              >
                Suivant
                {theme.direction === 'rtl' ? (
                  <KeyboardArrowLeft />
                ) : (
                  <KeyboardArrowRight />
                )}
              </Button>
            }
            backButton={
              <Button size="small" onClick={handleBack} disabled={activeStep === 0}>
                {theme.direction === 'rtl' ? (
                  <KeyboardArrowRight />
                ) : (
                  <KeyboardArrowLeft />
                )}
                Précédent
              </Button>
            }
          /> : <Box px={0} py={1} sx={{position : 'relative', background : 'white', textAlign : 'center'}}>
                <IconButton  onClick={() => setActiveStep(0)} variant="contained" size="large" sx={{position :'absolute', left: 5}}><KeyboardArrowLeft /></IconButton >

                <Button onClick={() => { 
                    saveGameFact(state)
                    if(callback) 
                      callback(state)
                  }} variant="contained" color="success" startIcon={<CheckIcon />} >Confirmer</Button>
              </Box>}
        </Box>
    )
}


const GenericGameFact = ({steps, state, activeStep, onSelect, recapComponent, match, onChangeText, onChangeTitle, searchFilter, surchargePeriod}) => {

  return activeStep < steps.length ? 
  React.createElement(steps[activeStep].description, {isCoachSelectable : steps[activeStep].isCoachSelectable, activeState : state, searchFilter, match, surchargePeriod, onSelect : (idItem) => onSelect(idItem), items : steps[activeStep].items, filter : eval(steps[activeStep].filter), array : steps[activeStep].array, noAnswer : steps[activeStep].noAnswer,custoAnswers : steps[activeStep].custoAnswers, selected : state[steps[activeStep].id]
  }) : 
  React.createElement(recapComponent, {state, match, onChangeText, onChangeTitle})

}

export default GameFact